<template>
  <div class="faceTwoForm">
    <img class="faceBg" src="@/assets/imgs/faceTwoBg.png" alt="" />
    <div class="tips">请录制 <span>3-5秒多次眨眼</span> 视频</div>
    <div class="button">
      <van-button type="primary" block @click="begin">开始录制</van-button>
    </div>
    <input
      type="file"
      accept="video/*"
      capture="camera"
      ref="input"
      v-show="false"
      @change="onChange"
    />
  </div>
</template>
<script>
  import Api from '@/api'
  import { mapState } from 'vuex'
  import { Toast } from 'vant'

  export default {
    data() {
      return {
        videoBase64: '',
      }
    },
    computed: {
      ...mapState({
        signInfo: state => state.sign,
        formData: state => state.authentication,
      }),
    },
    mounted() {},
    methods: {
      begin() {
        this.$refs.input.click()
      },
      onChange(event) {
        this.toast = Toast.loading({
          message: '签署中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 60000,
        })
        const file = event.target.files[0]
        console.log(file.size / 1024 / 1024)
        if (file.size > 16 * 1024 * 1024) {
          this.toast.clear()
          this.$toast('文件过大,请重新录制')
          return
        }
        this.videoType = file.type
        const reader = new FileReader()
        const rs = reader.readAsDataURL(file)
        reader.onload = e => {
          this.videoBase64 = e.target.result
          this.livenessVerifyDirect()
        }
      },
      async livenessVerifyDirect() {
        try {
          const param = {
            flowId: this.signInfo.flowId,
            idCardNo: this.formData.idCardNo,
            userName: this.formData.userName,
            videoType: 'mp4',
            videoBase64: this.videoBase64.replace('data:video/mp4;base64,', ''),
          }
          const { data } = await Api.livenessVerifyDirect(param)
          this.toast.clear()
          const { verifyStatus } = data
          if (verifyStatus === '1') {
            this.$router.push('/authentication/face/result')
          }
        } catch (error) {
          console.log(error)
          this.toast.clear()
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  .faceTwoForm {
    .faceBg {
      width: 100%;
      margin-bottom: 60px;
    }
    .tips {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: center;
      color: #111a34;
      line-height: 20px;
      margin-bottom: 24px;
      span {
        font-size: 20px;
        color: #1676ff;
      }
    }
    .button {
      padding: 0 16px;
    }
    .videoForm {
      position: absolute;
      left: 0;
      top: 0;
      background: #666;
      width: 100%;
      height: 100%;
      .tag {
        font-size: 14px;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
      }
      #video {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
</style>
